import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    FactorIdEnum,
    ModifiableCodeEnum,
    PolicyProductIdEnum,
    PolicyValidityStatusCodeEnum,
    ProductPremiumDeterminingFactorResponseInterface,
    PurchasedProductInterface,
} from 'outshared-lib';
import { INFORMATION_TOOLTIP_IDS } from '../enums/premium-determining-factor.config';
import { InsurancePremiumDeterminingFactorService } from '../insurance-premium-determining-factors.service';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '@app/shared/tooltip/tooltip.module';
import {
    WucButtonModule,
    WucDisplayFieldModule,
    WucIconUiModule, WucLinkModule,
    WucRackModule,
} from '@inshared/website-ui-components';

@Component({
    selector: 'ins-insurance-premium-determining-factor-data',
    templateUrl: './insurance-premium-determining-factor-data.component.html',
    styleUrls: ['./insurance-premium-determining-factor-data.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TooltipModule,
        WucRackModule,
        WucDisplayFieldModule,
        WucButtonModule,
        WucIconUiModule,
        WucLinkModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsurancePremiumDeterminingFactorDataComponent implements OnInit {

    @Input() public premiumDeterminingFactor!: ProductPremiumDeterminingFactorResponseInterface;
    @Input() public purchasedProduct!: PurchasedProductInterface;
    @Input() public selected!: boolean;

    @Output() selectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    public validityStatusCodeEnum: typeof PolicyValidityStatusCodeEnum;
    public modifiableCodeEnum: typeof ModifiableCodeEnum;
    public factorIdEnum: typeof FactorIdEnum;
    public hasInformationTooltip: boolean = false;

    constructor(
        private insurancePremiumDeterminingFactorService: InsurancePremiumDeterminingFactorService,
    ) {
        this.validityStatusCodeEnum = PolicyValidityStatusCodeEnum;
        this.modifiableCodeEnum = ModifiableCodeEnum;
        this.factorIdEnum = FactorIdEnum;
    }

    public ngOnInit(): void {
        this.validateInformationTooltip();
    }

    public get canAddPremiumDeterminingFactor(): boolean {
        return Boolean(
            this.premiumDeterminingFactor?.modifiableCode === ModifiableCodeEnum.Client &&
            !this.premiumDeterminingFactor?.modifiableFactorFuture &&
            [PolicyValidityStatusCodeEnum.Active, PolicyValidityStatusCodeEnum.ActiveChange]
                .includes(this.purchasedProduct?.product?.validityStatusCode));
    }

    public get isFutureProduct(): boolean {
        return Boolean([
            PolicyValidityStatusCodeEnum.Future,
            PolicyValidityStatusCodeEnum.Transfer,
        ].includes(this.purchasedProduct?.product?.validityStatusCode));
    }

    public get isDamageFreeYears(): boolean {
        return Boolean(this.premiumDeterminingFactor?.factorId === FactorIdEnum.DamageFreeYears);
    }

    public get isBonusMalusStep(): boolean {
        return Boolean(this.premiumDeterminingFactor?.factorId === FactorIdEnum.BonusMalusStep);
    }

    public openDamageFreeYearsModal(productId: PolicyProductIdEnum): void {
        this.insurancePremiumDeterminingFactorService.openDamageFreeYearsModal(productId);
    }

    public openBonusMalusStepModal(productId: PolicyProductIdEnum): void {
        this.insurancePremiumDeterminingFactorService.openBonusMalusStepModal(productId);
    }

    private validateInformationTooltip(): void {
        this.hasInformationTooltip = INFORMATION_TOOLTIP_IDS
            .includes(this.premiumDeterminingFactor.factorId);
    }

    public toggleForm(): void {
        return this.selectedChange.emit(!this.selected);
    }
}
